import { FC } from 'react';
import { InputField } from '@namespace/forms';
import { LoadTaxesType } from '../../../../../common/Tax/TaxByVoucher';

type TaxComponentType = FC<{ loadTaxes: LoadTaxesType }>;

type VoucherCodeFieldProps = {
  name: string;
  mask: string;
  taxComponent: TaxComponentType;
  loadTaxes: LoadTaxesType;
};
type VoucherCodeFieldComp = FC<VoucherCodeFieldProps>;

export const VoucherCodeField: VoucherCodeFieldComp = ({
  name,
  mask = '9999 9999 9999 9999',
  taxComponent: Tax,
  loadTaxes,
  ...props
}) => {
  return (
    <>
      <InputField name={name} mask={mask} {...props} />
      <Tax loadTaxes={loadTaxes} />
    </>
  );
};
